export enum NavRoute {
  OVERVIEW = '',
  DESIGN = 'design',
  DEPLOY = 'deploy',
  MONITOR = 'monitor',
  SETTINGS = 'settings',
  ADMIN = 'admin',
}

export type SidebarRoute =
  | DesignRoute
  | DeployRoute
  | MonitorRoute
  | SettingsRoute
  | AdminRoute;

export enum DesignRoute {
  PIPELINES = 'pipelines',
  MODELS = 'models',
  SOLUTIONS = 'solutions',
  MARKETPLACE = 'marketplace',
}

export enum DeployRoute {
  GATEWAYS = 'gateways',
  CAMERAS = 'cameras',
  STREAMS = 'streams',
  FILES = 'files',
  TRACKABLES = 'trackables',
  DEPLOYMENTS = 'deployments',
  EVENTS = 'events',
  RAPID_DEPLOY = 'new',
}

export enum MonitorRoute {
  SEARCH = 'search',
  DASHBOARDS = 'dashboards',
}

export enum SettingsRoute {
  ACCESS_TOKENS = 'access-tokens',
  UNIVERSAL_BRIDGE = 'universal-bridge',
  METRICS = 'metrics',
  WORKSPACE_UTILIZATION = 'workspace-utilization',
  GROUPS = 'groups',
  ORGANIZATION = 'organization',
  PLAN = 'plans',
  MEMBERS = 'members',
  ACCOUNT = 'account',
  PASSWORD = 'password',
  NOTIFICATION_RULES = 'notification-rules',
  NOTIFICATION_CHANNELS = 'notification-channels',
}

export enum AdminRoute {
  MARKETPLACE_MODELS = 'marketplace-models',
}

export function organizationPlansPath(
  applicationId: string | undefined,
  organizationId: string | undefined
) {
  return `/applications/${applicationId}/${NavRoute.SETTINGS}/${SettingsRoute.ORGANIZATION}/${organizationId}/${SettingsRoute.PLAN}`;
}
